import { useV2GetProjectByIdQuery, V2ProjectLocationResource } from "@generated";
import { Project } from "../../types";

const useGetProjectById = (
  id: string,
  options?: { refetchOnMountOrArgChange?: boolean }
) => {
  let customError: string | null = null; // Declare customError

  const { data, isLoading, isFetching, error } = useV2GetProjectByIdQuery(
    {
      id,
      include: ["project-locations", "rate-table"],
    },
    options
  );

  let project: Project | undefined = undefined;

  if (data?.data) {
    try {
      const p = data.data;
      const locations =
        p.relationships?.["project-locations"]?.data
          ?.map((l) => {
            const location = data?.included?.find?.(
              (item) =>
                item.type === "project-locations" &&
                item.id == l.id &&
                //@ts-ignore
                item.attributes?.active
            ) as V2ProjectLocationResource;
            return {
              label: String(location?.attributes?.name || ""),
              value: String(location?.id || ""),
            };
          })
          ?.filter((l) => l.value) || [];
      if (p?.id && p?.relationships) {
        project = {
          id: p.id,
          status: p?.attributes?.status,
          locations,
          rateTableId: p.relationships?.["rate-table"]?.data?.id,
          executiveSummary: p?.attributes?.["executive-summary"],
          solutionSummary: p?.attributes?.["solution-summary"],
          ourResponsibilities: p?.attributes?.["our-responsibilities"],
          customerResponsibilities: p?.attributes?.["client-responsibilities"],
          outOfScope: p?.attributes?.["out-of-scope"],
        };
      }
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    project,
    isLoading,
    isFetching,
    error: error ?? customError,
  };
};
export default useGetProjectById;
